import { render, staticRenderFns } from "./bottom-fixed.vue?vue&type=template&id=28ab7495&scoped=true&"
import script from "./bottom-fixed.vue?vue&type=script&lang=js&"
export * from "./bottom-fixed.vue?vue&type=script&lang=js&"
import style0 from "./bottom-fixed.vue?vue&type=style&index=0&id=28ab7495&lang=scss&scoped=true&"
import style1 from "./bottom-fixed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab7495",
  null
  
)

export default component.exports